import React from 'react';
import { FaDownload } from 'react-icons/fa';
import { useTranslation } from '../i18n';
import recursos from '../../assets/recursos/resourcesData';
import * as S from './ResourcesSection.styles';

function ResourcesSection() {
  const t = useTranslation();

  return (
    <S.ResourcesGrid>
      {recursos.length > 0 ? (
        // Display downloadable resources with preview images
        recursos.map((recurso) => {
          const IconComponent = recurso.icon;
          return (
            <S.DownloadableResourceCard key={recurso.id}>
              <S.ResourcePreviewImage>
                <img src={recurso.previewImage} alt={recurso.title} />
              </S.ResourcePreviewImage>
              <S.ResourceContent>
                <S.ResourceTitle>{recurso.title}</S.ResourceTitle>
                <S.ResourceDescription>{recurso.description}</S.ResourceDescription>
                <S.DownloadButton 
                  href={recurso.fileUrl || recurso.file} 
                  download={recurso.fileName}
                  aria-label={`${t('resources.downloadLabel')} ${recurso.title}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaDownload />
                  {t('resources.download')}
                </S.DownloadButton>
              </S.ResourceContent>
              <S.ResourceIconBadge>
                <IconComponent />
              </S.ResourceIconBadge>
            </S.DownloadableResourceCard>
          );
        })
      ) : (
        // Display placeholder cards when no resources are available
        <>
          <S.ResourceCard>
            <S.ResourceIcon>📄</S.ResourceIcon>
            <S.ResourceTitle>{t('resources.placeholders.guides.title')}</S.ResourceTitle>
            <S.ResourceDescription>
              {t('resources.placeholders.guides.description')}
            </S.ResourceDescription>
            <S.ResourceButton disabled>
              {t('resources.download')}
            </S.ResourceButton>
            <S.ComingSoonBadge>{t('resources.comingSoon')}</S.ComingSoonBadge>
          </S.ResourceCard>
          
          <S.ResourceCard>
            <S.ResourceIcon>📊</S.ResourceIcon>
            <S.ResourceTitle>{t('resources.placeholders.presentations.title')}</S.ResourceTitle>
            <S.ResourceDescription>
              {t('resources.placeholders.presentations.description')}
            </S.ResourceDescription>
            <S.ResourceButton disabled>
              {t('resources.download')}
            </S.ResourceButton>
            <S.ComingSoonBadge>{t('resources.comingSoon')}</S.ComingSoonBadge>
          </S.ResourceCard>
          
          <S.ResourceCard>
            <S.ResourceIcon>📚</S.ResourceIcon>
            <S.ResourceTitle>{t('resources.placeholders.additionalMaterial.title')}</S.ResourceTitle>
            <S.ResourceDescription>
              {t('resources.placeholders.additionalMaterial.description')}
            </S.ResourceDescription>
            <S.ResourceButton disabled>
              {t('resources.download')}
            </S.ResourceButton>
            <S.ComingSoonBadge>{t('resources.comingSoon')}</S.ComingSoonBadge>
          </S.ResourceCard>
        </>
      )}
    </S.ResourcesGrid>
  );
}

export default ResourcesSection;

